module.exports = __webpack_public_path__ + "img/GoblinMale_Heavy.c9daff44.gif";